import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class BirdService {

  constructor(private http: HttpClient) { }

  getSoundsBySciName(pSciName: string) {
    return this.http.get('https://api.globalbirdwatching.org/xenocanto/sounds?sciname=' + pSciName);
  }

  getPicsBySciName(pSciName: string) {
    return this.http.get('https://api.globalbirdwatching.org/db/fotosespecie?especie=' + pSciName);
  }

  getTaxonInfo(pSciName: string, pIdioma: string) {
    return this.http.get('https://api.globalbirdwatching.org/db/especiesporscinameporidioma?sciname=' + pSciName + '&idioma=' + pIdioma);
  }

  getColors(pSciName: string) {
    return this.http.get('https://api.globalbirdwatching.org/db/coloresporsciname?sciname=' + pSciName.trim().replace(/ /g, '-'));
  }

  getSoundMP3(pSciName: string, pIdSound: number) {
    return this.http.get('https://api.globalbirdwatching.org/xenocanto/sound/id?sciname=' + pSciName + '&id=' + pIdSound);
  }

  getHotSpotsGlobal(pSciName: string, pIdioma: string) {
    return this.http.get('https://api.globalbirdwatching.org/db/puntosavistamientoporidiomaporespecie?especie=' + pSciName + '&idioma=' + pIdioma);
  }

}
